export default __webpack_public_path__ + "static/media/landingBackground.d1f8e590.jpg";